const WIDGET_NAME = 'retell-fab';

export function removeRetellWidget() {
  const hosts = [...document.querySelectorAll('*')].filter((el) => {
    if (el.shadowRoot) {
      return el.shadowRoot.getElementById(WIDGET_NAME);
    }
  });

  hosts.forEach((host) => {
    const widget = host.shadowRoot.getElementById(WIDGET_NAME);
    if (widget) {
      widget.remove();
    }
  });
}
